import React, { useState, useEffect } from 'react';
import { Flex, Divider, Button } from 'antd';
import { useNavigate } from 'react-router-dom';
import caricon from '../../../images/car-icon.svg';
import useLineLiff from 'hooks/LineLiff';
import Header from 'pages/booking/components/Header';
import { decodeBase64Object, encodeBase64Object } from 'shared/common';

import '../../booking/booking.scss';

const Booking = () => {
  const navigate = useNavigate();
  const { liff, userInfo } = useLineLiff(process.env.REACT_APP_LIFF_ID_PNP);
  const [pageLoading, setPageLoading] = useState(true);
  const [pnpData, setPnpData] = useState({});

  useEffect(() => {
    if (!userInfo) return;

    const idToken = liff.getIDToken();

    const queryParams = Object.fromEntries(
      new URLSearchParams(window.location.search)
    );
    // decode base64
    const decodedParams = decodeBase64Object(queryParams);
    setPnpData(decodedParams);

    document.title = `LEXUS | ${
      decodedParams.title || queryParams.get('title')
    }`;

    setPageLoading(false);
  }, [userInfo]);

  const handleAddToCalendar = () => {
    const eventConfig = {
      title: 'LEXUS 預約服務',
      description: [
        pnpData.description || '',
        `車牌號碼: ${pnpData.work_no || ''}`,
        `預約服務廠: ${pnpData.location || ''}`,
        `預約人手機號碼: ${pnpData.phone || ''}`,
        pnpData.remark ? `備註: ${pnpData.remark}` : '',
      ]
        .filter(Boolean)
        .join('\n'),
      location: pnpData.location || '',
      startDate: pnpData.appointed_date,
      startTime: pnpData.appointed_time,
      filename: 'lexus-booking.ics',
      categories: ['LEXUS', 'Booking', 'Service'],
    };

    const buildQueryParams = new URLSearchParams(
      encodeBase64Object({
        title: eventConfig.title,
        description: eventConfig.description,
        location: eventConfig.location,
        startDate: eventConfig.startDate,
        startTime: eventConfig.startTime,
        filename: eventConfig.filename,
        categories: eventConfig.categories.join(','),
      })
    ).toString();

    const fullUrl = `${window.location.origin}/hotai/lexus/pnp/downloadCalendar?${buildQueryParams}`;

    liff.openWindow({
      url: fullUrl,
      external: true,
    });
  };

  const handleCancelRegistration = () => {
    if (!pnpData.id) {
      console.error('No booking ID found');
      return;
    }

    const queryParams = new URLSearchParams(encodeBase64Object(pnpData));

    // 帶著 pnp id 跳轉到取消預約頁面
    navigate(`/hotai/lexus/pnp/bookingCancel?${queryParams.toString()}`);
  };

  const renderField = (label, value, showDivider = false) => (
    <>
      <div className="form-content">
        <Flex align="center">
          <span
            className="form-subtitle"
            style={{ width: '140px', minWidth: '140px' }}>
            {label}:
          </span>
          <span
            className="form-subtitle"
            style={{ fontWeight: 'bold', textAlign: 'left' }}>
            {value || '-'}
          </span>
        </Flex>
      </div>
      {showDivider && <Divider style={{ margin: '12px 0' }} />}
    </>
  );

  return (
    <div className="booking-container">
      <Header />
      <div className="form-container">
        <div className="form-section">
          <div
            className="form-content"
            style={{ textAlign: 'center', marginBottom: '24px' }}>
            <Flex align="center" gap="small">
              <img src={caricon} alt="Car icon" />
              <div className="form-title">LEXUS {pnpData.title}</div>
            </Flex>
          </div>

          <div className="form-content">
            <div className="form-subtitle">
              <span>{pnpData.description}</span>
            </div>
          </div>

          {renderField('車牌號碼', pnpData.work_no)}
          {renderField('預約服務廠', pnpData.location)}
          {renderField('預約日期', pnpData.appointed_date)}
          {renderField('預約時段', pnpData.appointed_time)}
          {/* {renderField('預約人姓名', pnpData.customerName)} */}
          {renderField('預約人手機號碼', pnpData.phone)}
          {/* {renderField('在廠等候', pnpData.onSiteWaiting)}
          {renderField('預約取送車服務', pnpData.needsPickupService)}
          {renderField('預約取送車地址', pnpData.pickupAddress)}
          {renderField('電話聯絡時段', pnpData.phoneContactPeriod)}
          {renderField('其他意見', pnpData.otherComments, false)} */}

          {pnpData.remark && (
            <>
              <Divider style={{ margin: '12px 0' }} />
              <div className="form-content">
                <div
                  className="form-subtitle"
                  style={{
                    fontSize: '12px',
                    color: '#888',
                    fontWeight: 'normal',
                    opacity: 0.8,
                  }}>
                  <span>{pnpData.remark}</span>
                </div>
              </div>
            </>
          )}
        </div>

        <div
          style={{
            marginTop: '24px',
            display: 'flex',
            flexDirection: 'column',
            gap: '12px',
          }}>
          <Button
            type="primary"
            size="large"
            onClick={handleAddToCalendar}
            loading={pageLoading}
            style={{
              height: '50px',
              fontSize: '16px',
              fontWeight: 'bold',
              backgroundColor: '#52c41a',
              borderColor: '#52c41a',
              borderRadius: '8px',
            }}>
            加入行事曆
          </Button>

          <Button
            type="default"
            size="large"
            onClick={handleCancelRegistration}
            loading={pageLoading}
            style={{
              height: '50px',
              fontSize: '16px',
              fontWeight: 'bold',
              color: '#ff4d4f',
              borderColor: '#ff4d4f',
              borderRadius: '8px',
            }}>
            取消預約
          </Button>
        </div>
      </div>
    </div>
  );
};

export default Booking;
